<ng-container *ngIf="user; else noUser">
    <mat-drawer-container #matDrawerContainer (backdropClick)="closeBackdrop()">
      <mat-drawer role="navigation" position="end" #rightnav>
        <uni-right-sidenav
          [user]="user"
          (toLogout)="logout($event)">
        </uni-right-sidenav>
      </mat-drawer>

      <mat-drawer-content>
        <uni-header
          [user]="user"
          [search]="true"
          [transparentHeader]="true"
          (searchPage)="goToSearchPage($event)"
          (searchText)="goToSearchPage($event)"
          (rightSidenav)="rightToggle($event)">
        </uni-header>
        <main class="app-main" >
          <router-outlet></router-outlet>
        </main>
      </mat-drawer-content>
    </mat-drawer-container>
</ng-container>

<ng-template #noUser>
  <mat-drawer-container>
    <mat-drawer-content>
      <uni-header
        [search]="true"
        [transparentHeader]="true"
        (searchPage)="goToSearchPage($event)"
        (searchText)="goToSearchPage($event)">
      </uni-header>
      <main class="app-main" >
        <router-outlet></router-outlet>
      </main>
    </mat-drawer-content>
  </mat-drawer-container>
</ng-template>
